import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes, states } from '@/utils'

import buttonRefresh from '@/components/button/refresh'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import dialog from '@/components/services/url-shortener/cols/second/dialog'
import item from '@/components/services/url-shortener/cols/second/item'
import clientIp from '@/components/services/url-shortener-tracking/commons/clientIp'

function renderDialog(h) {
  return h(
    dialog,
    {
      props: {
        value: this.showDialog,
        data: this.item
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    }
  )
}

function renderHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.tab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.tab = event
        }
      }
    }
  )
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}

function renderFilter(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener-tracking']}-tab__filter`
    },
    [
      h(
        clientIp,
        {
          props: {
            value: this.clientIp,
            labelMode: labelModes.hidden
          },
          on: {
            input: event => {
              this.clientIp = event
            }
          }
        }
      )
    ]
  )
}
function renderItem(h, value) {
  return h(
    item,
    {
      props: { value },
      on: {
        click: () => {
          this.item = value
          this.showDialog = !this.showDialog
        }
      }
    }
  )
}
function renderItems(h) {
  return this.restData[Services['url-shortener-tracking']].find.data.map(item => {
    return renderItem.call(this, h, item)
  })
}
function renderPagination(h) {
  return h(
    pagination,
    {
      props: {
        value: this.restData[Services['url-shortener-tracking']].find.pagination,
        service: Services['url-shortener-tracking'],
        selectRows: false
      },
      on: {
        input: event => {
          this.restData[Services['url-shortener-tracking']].find.pagination = event
        }
      }
    }
  )
}
function renderRefreshButton(h) {
  return h(
    buttonRefresh,
    {
      props: {
        state: this.restData[Services['url-shortener-tracking']].find.state,
        shortClickMethod: () => {
          return this.rest[Services['url-shortener-tracking']].find()
        }
      }
    }
  )
}
function renderDivider(h) {
  return h(components.divider)
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener-tracking']}-tab__footer`
    },
    [
      renderPagination.call(this, h),
      renderRefreshButton.call(this, h)
    ]
  )
}
function renderContent(h) {
  switch (this.restData[Services['url-shortener-tracking']].find.state) {
    case states.loading: return renderPreloader.call(this, h)
    case states.ready: {
      if (this.restData[Services['url-shortener-tracking']].find.pagination.total > 0) {
        return [
          renderItems.call(this, h),
          renderDialog.call(this, h)
        ]
      }

      return h(components.empty)
    }
  }
}
function renderTab(h) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true
      },
      key: Services['url-shortener-tracking']
    },
    [
      renderFilter.call(this, h),
      renderDivider.call(this, h),
      renderContent.call(this, h),
      renderDivider.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
function renderBody(h) {
  return h(
    components.tabs,
    {
      props: { value: this.tab },
      scopedSlots: {
        body: () => {
          return this.tabs.map(tab => {
            return renderTab.call(this, h, tab.key)
          })
        }
      }
    }
  )
}

export default function(h) {
  if (this.canGet) {
    return h(
      'div',
      {
        class: `${Services['url-shortener-tracking']}-tab`
      },
      [
        renderHeader.call(this, h),
        renderBody.call(this, h)
      ]
    )
  }
}
